export const gridMargins = {
  xs: 24,
  sm: 40,
  md: 64,
  lg: 80,
  xl: 80,
} as const;

export const GRID_CONTENT_MAX_WIDTH_PX = 1280;
